import Icona from '../../../components/3catinfo/ui/Icona';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './etiqueta.module.scss';

export default function Etiqueta(props) {
    const { text, icona, isBlanc, tipus, className, estil, size } = props;

    const styleEtiqueta = clsx({
        [styles.etiqueta]: true,
        [styles.ambIcona]: !__isEmpty(icona),
        [styles[tipus]]: !__isEmpty(tipus),
        [styles[size]]: !__isEmpty(tipus),
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    return (
        <div className={styleEtiqueta}>
            {!__isEmpty(icona) && <Icona className={styles.icona} icona={icona} isBlanc={isBlanc} ariaHidden={true} />}
            <span data-testid='etiqueta-text'>{text}</span>
        </div>
    );
}
